import { AlertCircle } from '@saleshandy/icons';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { accessibleOnClick } from '../../../../../../../../../shared/utils/accessible-on-click';

type IProps = {
  show: boolean;
  onCancel: () => void;
  onHide: () => void;
};

const ProspectRemoveFromSequenceAlertModal: React.FC<IProps> = ({
  show,
  onHide,
  onCancel,
}) => (
  <Modal
    show={show}
    onCancel={onHide}
    className="prospect-remove-from-sequence-alert-modal"
    backdrop="static"
    centered
  >
    <div className="prospect-remove-from-sequence-alert-modal-container">
      <div className="prospect-remove-from-sequence-alert-modal-content">
        <div className="prospect-remove-from-sequence-alert-modal-header">
          <div className="header-title">
            <AlertCircle width={24} height={24} color="#D97706" />
            <span className="line-height-1">
              Remove prospect from sequence?
            </span>
          </div>
        </div>
        <div className="prospect-remove-from-sequence-alert-modal-body">
          <span className="prospect-remove-from-sequence-alert-modal-text">
            Once removed, this prospect won’t receive any more emails or
            follow-ups from this sequence. You can re-add them anytime if you
            decide to continue the conversation.
          </span>
        </div>
      </div>
      <div className="divider-line" />
    </div>
    <div className="prospect-remove-from-sequence-alert-modal-footer">
      <div className="cancel-btn" {...accessibleOnClick(onCancel)}>
        Cancel
      </div>
      <div className="proceed-btn" {...accessibleOnClick(onHide)}>
        <Button>Yes</Button>
      </div>
    </div>
  </Modal>
);


export default ProspectRemoveFromSequenceAlertModal;
